import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReportService } from '@core/report/report.service';
import { select, Store } from '@ngrx/store';
import { selectPortalConfig } from '@platform/platform.selectors';
import { PortalConfig } from '@platform/platform.state';
import { pendingFlag, withPendingFlag } from '@platform/shared/utilities/pending-flag';
import { ToastService } from '@platform/toast/toast.service';
import { RootState } from '@root/app.state';
import saveAs from 'file-saver';
import { AdminActionItemComponent } from '../ui/admin-action-item.component';
import { AdminPageSectionComponent } from '../ui/admin-page-section.component';
import { ButtonIndicatorDownloadComponent } from '../ui/button-indicator-download.component';

@Component({
  selector: 'app-access-report-section',
  imports: [AdminPageSectionComponent, AdminActionItemComponent, ButtonIndicatorDownloadComponent],
  templateUrl: './access-report-section.component.html',
  styleUrl: './access-report-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessReportSectionComponent {
  public readonly customerSpaceReportPending = pendingFlag();
  public readonly projectReportPending = pendingFlag();
  public readonly userReportPending = pendingFlag();

  public readonly portalConfig: Signal<PortalConfig | null | undefined>;

  constructor(
    private store$: Store<RootState>,
    private reportService: ReportService,
    private toastService: ToastService,
  ) {
    this.portalConfig = toSignal(store$.pipe(select(selectPortalConfig)));
  }

  public downloadCustomerSpaceReport() {
    this.reportService
      .getCustomerSpaceReport()
      .pipe(withPendingFlag(this.customerSpaceReportPending))
      .subscribe({
        next: (response) => saveAs(response, `Berechtigungsreport_MYO2_Kundenraum_${formatDate(new Date(), 'yyyyMMdd', 'en')}.xlsx`),
        error: () => this.toastService.showErrorToast('admin.reports.error-message'),
        complete: () => this.toastService.showSuccessToast('admin.reports.success-message'),
      });
  }

  public downloadProjectReport() {
    this.reportService
      .getProjectReport()
      .pipe(withPendingFlag(this.projectReportPending))
      .subscribe({
        next: (response) => saveAs(response, `Berechtigungsreport_MYO2_Projekt_${formatDate(new Date(), 'yyyyMMdd', 'en')}.xlsx`),
        error: () => this.toastService.showErrorToast('admin.reports.error-message'),
        complete: () => this.toastService.showSuccessToast('admin.reports.success-message'),
      });
  }

  public downloadUserReport() {
    this.reportService
      .getUserReport()
      .pipe(withPendingFlag(this.userReportPending))
      .subscribe({
        next: (response) => saveAs(response, `Berechtigungsreport_MYO2_Benutzer_${formatDate(new Date(), 'yyyyMMdd', 'en')}.xlsx`),
        error: () => this.toastService.showErrorToast('admin.reports.error-message'),
        complete: () => this.toastService.showSuccessToast('admin.reports.success-message'),
      });
  }
}
